import { render, staticRenderFns } from "./Participant.vue?vue&type=template&id=47a13028&"
import script from "./Participant.vue?vue&type=script&lang=js&"
export * from "./Participant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports